<script setup lang="ts">
import SSHeader from '../components/SSHeader.vue'
import SSFooter from '../components/footer/SSFooter.vue'
</script>

<template>
  <SSHeader />
  <main class="ss-app__main" data-testid="ss-app-main-base-layout">
    <slot name="main-content" />
  </main>
  <SSFooter />
</template>
